{
  "aboutFarmUserPermissions": "About Farm-User Permissions",
  "canControlDevicesRemotely": {
    "displayName": "Use Remote Controls",
    "extendedDescription": "Send direct commands and requests to your farm's devices, which can allow you to control their switches and perform other actions."
  },
  "canManageCustomTriggers": {
    "displayName": "Create Device Connections",
    "extendedDescription": "Create, modify, and delete connections between devices, including actions that can triggered if a device changes from one state to another."
  },
  "canManageDeviceConfiguration": {
    "displayName": "Change Configurations",
    "extendedDescription": "Create, modify, and delete device sensor calibrations and device customizations (the device's in-app display name, for example)."
  },
  "canManageDeviceNotifications": {
    "displayName": "Manage Device Notifications",
    "extendedDescription": "Set up alerts to notify your crew when a device's state changes. Mute or unmute device notifications for all users."
  },
  "canManageDevicePermissions": {
    "displayName": "Share Devices",
    "extendedDescription": "Manage access to and control of a specific device for other users in our outside of your farm."
  },
  "canManageFarmAccount": {
    "displayName": "Change Farm Account Details",
    "extendedDescription": "Manage details related to business administration (e.g. change the farm's listed address). "
  },
  "canManageFields": {
    "displayName": "Manage Fields",
    "extendedDescription": "Create, edit, and delete your farm's field's and associated irrigation records."
  },
  "canManageJoinCodes": {
    "displayName": "Manage Farm Join Codes",
    "extendedDescription": "Grant users access and permissions to your farm account."
  },
  "canManageSchedules": {
    "displayName": "Manage Device Schedules",
    "extendedDescription": "Create and edit one-time and recurring actions for devices."
  },
  "canManageUserPermission": {
    "displayName": "Edit Other User Permissions",
    "extendedDescription": "Grant or revoke farm-level permissions to other users in your farm."
  },
  "devicePermissionsDescription": "Allow user to perform actions on the farm's devices.",
  "devicePermissionsTitle": "Device Permissions",
  "farmPermissionsDescription": "Allow user to manage aspects of the farm account.",
  "farmPermissionsTitle": "Farm Permissions",
  "farmUserPermissionsAllowYouTo": "Farm and device permissions allow you to take certain actions within FarmHQ. These permissions can be granted or revoked by a farm administrator.",
  "farmUserPermissionsHelpSummary": "Farm-User permissions dictate which actions can be performed by a given user. This allows a farm manager to protect his/her devices from being misused by others (intentionally or otherwise).\n\nIt also can also free the farm manager and other farm workers from worrying about accidentally taking actions that may have unintended consequences.",
  "farmUserPermissionsTitle": "Farm-User Permissions",
  "permissionDenied": "Permission Denied",
  "thisPermission": "This permission:",
  "youDoNotHavePermission": "You do not have permission to perform this action. Contact an administrator of your account to gain access.",
  "youDoNotHavePermissionToAccessThisResource": "You do not have permission to access this resource. Contact an administrator of your account to gain access."
}
